import { useMutation } from "@tanstack/react-query";
import { fetch } from "libs";
import { POST_CREATE_STRIPE_CHECKOUT_SESSION } from "api";
import { loadStripe } from "@stripe/stripe-js";

const STRIPE_API_KEY = process.env.NEXT_PUBLIC_STRIPE_API_KEY;

if (STRIPE_API_KEY === undefined) {
  throw new Error("NEXT_PUBLIC_STRIPE_API_KEY not set");
}

const stripePromise = loadStripe(STRIPE_API_KEY);

const createStripeCheckoutSession = async (plan_name: string) => {
  const POST_CREATE_STRIPE_CHECKOUT_SESSION_COM = POST_CREATE_STRIPE_CHECKOUT_SESSION(plan_name);

  const response = await fetch(POST_CREATE_STRIPE_CHECKOUT_SESSION_COM, {
    method: "POST",
    credentials: "include",
  });

  const stripe = await stripePromise;

  if (!stripe) {
    throw new Error("Stripe has not loaded");
  }

  const { error } = await stripe.redirectToCheckout({
    sessionId: response.session_id,
  });

  if (error) {
    throw new Error(error.message);
  }
};


export const useCreateStripeCheckoutSession = () => {
  return useMutation({
    mutationFn: async ({ plan_name }: { plan_name: string }) =>
      await createStripeCheckoutSession(plan_name),
    onSuccess: () => {
      console.log("Created Stripe session successfully");
    },
    onError: (error: any) => {
      console.error("Error creating Stripe session:", error);
    },
  });
};

export default useCreateStripeCheckoutSession;
